/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class WinterHoardReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected noWinStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            stateAnimation.tint = 0x555555;
        }
        return stateAnimation;
    }

    protected getBasicStateAnimation(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const sprite:TimelineSprite | null = super.getBasicStateAnimation(symbol, stateKey, stateConfig);

        if(stateKey === "normal"  && symbol.symName === "W") {
            sprite!.getAnimationAutoShowHide(true, false);
        }

        if(symbol.symName !== "S") {
            return sprite;
        }
        if(stateKey === "normal" || stateKey === "trigger") {
            sprite!.getAnimationAutoShowHide(true, false);
        }
        if(stateKey === "plus") {
            sprite!.playLoop();
        }
        return sprite;
    }

}